const IMAGE_PARAMS = 'w=400&h=300&fit=crop&q=80';

export const DEFAULT_CITY_IMAGE =
  `https://images.unsplash.com/photo-1566073771259-6a8506099945?${IMAGE_PARAMS}`;

export const CITY_IMAGES = {
  Paris: `https://images.unsplash.com/photo-1502602898657-3e91760cbb34?${IMAGE_PARAMS}`,
  London: `https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?${IMAGE_PARAMS}`,
  Tokyo: `https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?${IMAGE_PARAMS}`,
  Miami: `https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?${IMAGE_PARAMS}`,
  Rome: `https://images.unsplash.com/photo-1552832230-c0197dd311b5?${IMAGE_PARAMS}`,
  Dubai: `https://images.unsplash.com/photo-1512453979798-5ea266f8880c?${IMAGE_PARAMS}`,
  'New York': `https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?${IMAGE_PARAMS}`,
  Bali: `https://images.unsplash.com/photo-1537996194471-e657df975ab4?${IMAGE_PARAMS}`,
  Barcelona: `https://images.unsplash.com/photo-1583422409516-2895a77efded?${IMAGE_PARAMS}`,
  Prague: `https://images.unsplash.com/photo-1541849546449-dea637c9680a?${IMAGE_PARAMS}`,
  Cancun: `https://images.unsplash.com/photo-1510097467424-192d713fd8b2?${IMAGE_PARAMS}`,
  'Las Vegas': `https://images.unsplash.com/photo-1605833556294-ea5c7a74f57d?${IMAGE_PARAMS}`,
  'Los Angeles': `https://images.unsplash.com/photo-1580654712605-eb0b3c7aeeea?${IMAGE_PARAMS}`,
  Orlando: `https://images.unsplash.com/photo-1507249638527-7eaac6a70459?${IMAGE_PARAMS}`,
  'San Francisco': `https://images.unsplash.com/photo-1501594907352-04cda38ebc29?${IMAGE_PARAMS}`,
  Sydney: `https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?${IMAGE_PARAMS}`,
  Amsterdam: `https://images.unsplash.com/photo-1512478807229-8524d11236ee?${IMAGE_PARAMS}`,
  Singapore: `https://images.unsplash.com/photo-1525621488511-aba264c72035?${IMAGE_PARAMS}`,
  'Mexico City': `https://images.unsplash.com/photo-1518659094540-0c9174087363?${IMAGE_PARAMS}`,
  Hawaii: `https://images.unsplash.com/photo-1542259049836-0a5930a5a359?${IMAGE_PARAMS}`,
};

export const getCityImage = (city, fallback = DEFAULT_CITY_IMAGE) => {
  if (!city) {
    return fallback;
  }
  return CITY_IMAGES[city] || fallback;
};
